<i18n>
{
    "en": {},
    "ru": {
        "error": "Что-то пошло не так",
        "title": "Парфюмерный термин",
        "read_also": "Читайте также",
        "best_articles": "Лучшие статьи",
        "chained_pages": "Интересные подборки",
        "tooltip_share": "Поделиться",
        "faqTitle": "Что такое {title}?"
    }
}
</i18n>
<template>
    <div class="glossary-detail">

        <block-price-panel />

        <PageBlock :content-visible="isDeviceDesktop">
            <Breadcrumb
                show-prev-button
                prev-path-name="Glossary"
                :items="breadcrumbs"/>

            <SectionCard
                v-if="isDeviceDesktop"
                :sidebar="isDeviceDesktop ? 'detail' : false"
                :loaded="loaded">
                <template
                    #leftbar
                    v-if="isDeviceDesktop">

                    <div class="glossary-detail__picture-wrapper">
                        <span class="glossary-detail__img"
                            :style="{ backgroundImage: 'url(' + get(termData, 'picture.url', getNoImage) + ')' }">
                        </span>
                    </div>

                    <PageBlock
                        :smallTitle="isDeviceDesktop"
                        v-if="relatedArticles && relatedArticles.length"
                        :title="$t('best_articles')">
                        <div class="glossary__page-block">
                            <ArticleRowItem
                                :key="index + article"
                                v-for="(article, index) in relatedArticles"
                                :data="article"/>
                        </div>
                    </PageBlock>

                    <PageBlock
                        :smallTitle="isDeviceDesktop"
                        v-if="relatedPages && relatedPages.length"
                        :title="$t('chained_pages')">
                        <div class="glossary__page-block">
                            <LinkedPagesList :items="relatedPages"/>
                        </div>
                    </PageBlock>

                </template>

                <div
                    class="glossary-detail__rightbar"
                    slot="rightbar">

                    <div class="glossary-detail__buttons">
                        <ButtonSquare
                            class="rightbar__button"
                            icon="icon-share"
                            v-tooltip.top="{content: $t('tooltip_share'), offset: 14}"
                            :aria-label="$t('tooltip_share')"
                            @click.native="sharePage(termData)"/>
                    </div>

                    <h1
                        v-if="isDeviceDesktop"
                        class="glossary-detail__content">
                        <div class="glossary-detail__caption">
                            {{ $t('title') }}
                        </div>
                        <div class="glossary-detail__title"> {{ get(termData, 'name', '') }} </div>
                    </h1>

                    <!-- eslint-disable-next-line -->
                    <div v-html="get(termData, 'description', '')"
                        ref="desc"
                        class="glossary-detail__description html-content"></div>

                    <PageBlock
                        :content-visible="isDeviceDesktop"
                        v-if="relatedTerms && relatedTerms.length"
                        bigTitle
                        smallHeader
                        :title="$t('read_also')">
                        <CatalogList
                            id="glossary_list"
                            class="glossary-detail__catalog"
                            :items="relatedTerms"
                            itemMargin
                            :with-search="false"
                            :with-sort="false"
                            :with-pagination="false">
                            <template #item="{ item }" >
                                <BlockGroup
                                    picture-covered
                                    :border="isDeviceDesktop"
                                    picture-circle
                                    class="glossary-detail__catalog-item"
                                    :key="item.code"
                                    :picture="get(item, 'picture.url', null)"
                                    :name="item.name"
                                    :html-description="item.anons"
                                    :url="item.htmlUrl"
                                    :count="get(item, 'perfumes.total')"
                                    :hide-text-for-seo="true" />
                            </template>
                        </CatalogList>
                    </PageBlock>
                </div>

                <template
                    #main
                    v-if="!isDeviceDesktop">
                    <div class="glossary-detail__content">
                        <div class="glossary-detail__picture-wrapper">
                            <span class="glossary-detail__img"
                                :style="{ backgroundImage: 'url(' + get(termData, 'picture.url', getNoImage) + ')' }">
                            </span>
                            <div class="glossary-detail__caption">
                                {{ $t('title') }}
                            </div>
                        </div>
                        <div class="glossary-detail__title"> {{ get(termData, 'name', '') }} </div>
                    </div>
                </template>

                <template
                    #content
                    v-if="!isDeviceDesktop">
                    <!-- eslint-disable-next-line -->
                    <div v-html="get(termData, 'description', '')"
                        ref="desc"
                        class="glossary-detail__description html-content"></div>
                </template>
            </SectionCard>

            <SectionCard v-else :loaded="loaded">
                <div class="glossary-detail__rightbar"
                    slot="rightbar">

                    <ButtonSquare
                        class="rightbar__button"
                        icon="icon-share"
                        aria-label="share"
                        @click.native="sharePage(termData)"/>

                </div>
                <template #main>
                    <div class="glossary-detail__content">
                        <div class="glossary-detail__picture-wrapper">
                            <span class="glossary-detail__img"
                                :style="{ backgroundImage: 'url(' + get(termData, 'picture.url', getNoImage) + ')' }">        
                            </span>
                        </div>
                    </div>
                    <h1 class="glossary-detail__content">
                        <div class="glossary-detail__caption">
                            {{ $t('title') }}
                        </div>
                        <div class="glossary-detail__title"> {{ get(termData, 'name', '') }} </div>
                    </h1>
                </template>
                <template #content>
                    <!-- eslint-disable-next-line -->
                    <div v-html="get(termData, 'description', '')"
                        ref="desc"
                        class="glossary-detail__description"></div>
                </template>
            </SectionCard>

        </PageBlock>

        <PageBlock
            v-if="relatedTerms && relatedTerms.length && !isDeviceDesktop"
            :title="$t('read_also')">

            <CatalogList
                id="glossary_list"
                class="glossary-detail__catalog"
                :items="relatedTerms"
                :with-search="false"
                :with-sort="false"
                :with-pagination="false">
                <template #item="{ item }" >
                    <BlockGroup
                        picture-circle
                        picture-covered
                        class="glossary-detail__catalog-item"
                        :key="item.code"
                        :picture="get(item, 'picture.url', null)"
                        :name="item.name"
                        :html-description="item.anons"
                        :url="item.htmlUrl"
                        :count="get(item, 'perfumes.total')"
                        :hide-text-for-seo="true" />
                </template>
            </CatalogList>
        </PageBlock>

        <PageBlock v-if="relatedPages && relatedPages.length && !isDeviceDesktop" :title="$t('chained_pages')">
            <div class="glossary__page-block">
                <LinkedPagesList :items="relatedPages"/>
            </div>
        </PageBlock>

        <MicroMarkup
            :type="'glossary'"
            :headline="$t('faqTitle', {title: get(termData, 'name', '')})"
            :description="get(termData, 'description', '')" />

        <MicroMarkup
            :headline="$t('title') + ' ' + get(termData, 'name', '')"
            :date-published="termData.createdAt"
            :date-modified="termData.updatedAt"
            :image="get(termData, 'picture.url', getNoImage)"
            :article-body="termData.description"
            :name="'Aromo'" />

    </div>
</template>

<script>
import get from "lodash/get";
import { mapGetters } from "vuex";
import buttonActionsMixin from '@/mixins/catalog/buttonActions';

import PageBlock from '@/components/layout/AppPageBlock';
import Breadcrumb from '@/components/layout/nav/Breadcrumb';
import SectionCard from '@/components/layout/AppSectionCard';
import ButtonSquare from '@/components/ui/buttons/ButtonSquare';
import LinkedPagesList from '@/components/layout/blocks/LinkedPagesList';
import BlockGroup from '@/components/catalog/BlockGroup';
import ArticleRowItem from '@/components/layout/blocks/ArticlesList/ArticleRowItem'
import BlockPricePanel from '@/components/catalog/BlockPricePanel';
import CatalogList from '@/components/catalog/CatalogList';
import MicroMarkup from '@/components/catalog/MicroMarkup';

import Term from '@/models/catalog/Term'

export default {
    name: 'GlossaryDetail',
    components: {LinkedPagesList, BlockGroup, ButtonSquare, SectionCard, Breadcrumb, PageBlock, ArticleRowItem, BlockPricePanel, CatalogList, MicroMarkup},
    mixins: [buttonActionsMixin],
    asyncData({app, params, error}) {
        const baseUrl = app.i18n.__baseUrl

        const glossaryApi = new Term
        const glossaryModel = new Term({
            code: params.code
        })

        const catalogHref = app.router.resolve({
            name: 'Glossary'
        }).href

        const requests = [
            glossaryApi.find(params.code),
            glossaryModel.relatedTerms().get(),
            glossaryModel.relatedPages().get(),
            glossaryModel.relatedArticles().get(),
        ]

        return Promise.all(requests).then(results => {

            const termData = results[0]
            const relatedTerms = results[1]
            const relatedPages = results[2]
            const relatedArticles = results[3]

            const breadcrumbs = [
                {
                    path: baseUrl,
                    name: app.i18n.t('breadcrumbs.perfumes'),
                },
                {
                    path: baseUrl + catalogHref,
                    name: app.i18n.t('breadcrumbs.glossary'),
                },
                {
                    path: baseUrl + catalogHref + termData.code,
                    name: termData.name,
                }
            ];

            if (process.server) {
                app.store.dispatch('rest/headers/filterLastModified', {
                    url: [`/glossary/${termData.code}`]
                });
            }

            return {
                breadcrumbs,
                termData,
                relatedTerms,
                relatedPages,
                relatedArticles
            }
        }).catch((e) => {
            error({statusCode: e.response.status, message: e.response.data});
        });
    },
    data() {
        return {
            loaded: false,
            breadcrumbs: [],
            termData: {},
            relatedTerms: [],
            relatedArticles: [],
            relatedPages: []
        }
    },
    computed: {
        ...mapGetters(['getNoImage', 'isDeviceDesktop'])
    },
    mounted() {
        this.loaded = true;
        if(this.$refs.desc) {
            this.lazyLoadImage(this.$refs.desc)
        }
    },
    methods: {
        get,
        lazyLoadImage(e) {
            const media = e.querySelectorAll('[v-lazy-load]');
            [...media].forEach(m => this.$lazyLoad(m))
        }
    },
    head() {
        return {
            title: get(this.termData, 'meta.title'),
            meta: this.$options.filters.metaApiExtract(this.termData),
            link: [
                {
                    hid: 'i18n-can',
                    rel: 'canonical',
                    href: get(this.termData, 'meta.canonical')
                }
            ]
        }
    }
};
</script>

<style lang="less">
.glossary-detail {
    @{desktop} & {
        margin-bottom: rem(75);
    }

    &__content {
        text-align: center;

        margin-bottom: rem(10);

        @{mobile} & {
            padding-left: rem(20);
            padding-right: rem(20);
        }

        @{desktop} & {
            text-align: left;
            padding-right: rem(80);
            margin-bottom: rem(40);
        }

        h1&{
            @{mobile} & {
                margin-bottom: rem(12);
            }
        }
    }

    &__buttons {
        display: flex;
        flex-flow: row nowrap;

        position: absolute;
        top: 0;
        right: 0;

        .rightbar__button {
            position: relative;

            &:not(:first-of-type) {
                margin-left: rem(12);
            }
        }
    }

    &__picture-wrapper {
        @{desktop} & {
            .center-image(263);
            border: 1px solid @color-gray-white;
            border-radius: rem(5);

            margin-bottom: rem(38);
            padding: rem(40);

            height: rem(343);
        }
    }

    &__img{
        display: block;
        width: 100%;
        height: 100%;
        background-size: cover;
        border-radius: 50%;

        @{mobile} &{
            height: rem(160);
            width: rem(160);
            margin: 0 auto rem(20);
        }
    }

    &__caption {
        color: @color-gray;
        font-size: rem(15);
        line-height: rem(23);
        margin-bottom: rem(6);
        font-weight: 400;

        @{mobile} & {
            margin-bottom: rem(4);
        }
    }

    &__title {
        font-size: rem(18);
        font-weight: 500;

        @{desktop} & {
            font-size: rem(28);
            line-height: rem(36);
        }
    }

    &__description {

        @{desktop} & {
            margin-bottom: rem(70);
        }
    }

    &__catalog {
        margin-top: rem(10);

        .catalog-list__list {
            border-top: none;
        }

        &-item {
            @{desktop} & {
                --block-group-height: rem(160);
            }
        }
    }
}
</style>
